import axios from 'axios'

// const for dev server
// https://mytoolapi-dev.azurewebsites.net/api/public/search/item/?searchKeyword=a&itemType=PRODUCTS&RowsPerPage=10&PageNumber=1
//const host = 'https://mytool-api.azurewebsites.net';
//const host = 'https://mytoolapi-dev.azurewebsites.net';

//----- Dev Api -----
// const host = 'http://localhost:51239';
// const hostDashboard = 'http://localhost:4200/app/dashboard';

//----- Staging Api -----
// const host = 'http://api-staging.toolaku.com';
// const hostDashboard = 'http://cp-staging.toolaku.com/app/dashboard';

//----- Demo Api -----
// const host = 'http://demo.api.toolaku.com';
// const hostDashboard = 'http://demo.toolaku.com/app/dashboard';

//----- Live -----
const host = 'http://liveapi.toolaku.com/';
const hostDashboard = 'http://dashboard.toolaku.com/app/dashboard';
//Old live from azura server
// const hostDashboard = 'http://dashboard.toolaku.com';
// const hostDashboard = 'http://mytoolakucp-dev.azurewebsites.net/';

export default {
  getCategories() {
    return axios.get(`${host}/api/public/category/top10`)
  },
  getAllCategories() {
    return axios.get(`${host}/api/public/category/all`)
  },
  getRecommendedProducts() {
    return axios.get(`${host}/api/public/product/recommended`)
  },
  getRecommendedServices() {
    return axios.get(`${host}/api/public/service/recommended`)
  },
  getRfqTenderList() {
    return axios.get(`${host}/api/public/rfqtender/list`)
  },
  /*
  search(keyword, itemType) {
    //console.log("search :::::::::: ");
    return axios.get(`${host}/api/public/search/item?searchKeyword=${keyword}&itemType=${itemType}`)
    // return axios.get(`${hostLocal}/api/public/search/item?searchKeyword=&itemType=PRODUCTS&RowsPerPage=10&PageNumber=1`)
  },
  */
 search(keyword, itemType, RowsPerPage, PageNumber) {
    //console.log("search :::::::::: ",keyword,',', itemType, ',', RowsPerPage, ',', PageNumber);
    // return axios.get(`${host}/api/public/search/item?searchKeyword=&itemType=PRODUCTS&RowsPerPage=10&PageNumber=1`)
    return axios.get(`${host}/api/public/search/item?searchKeyword=${keyword}&itemType=${itemType}&RowsPerPage=${RowsPerPage}&PageNumber=${PageNumber}`)
  },
  searchItemCount(keyword) {
    //console.log("search :::::::::: ",keyword,',', itemType, ',', RowsPerPage, ',', PageNumber);
    // return axios.get(`${host}/api/public/search/item?searchKeyword=&itemType=PRODUCTS&RowsPerPage=10&PageNumber=1`)
    return axios.get(`${host}/api/public/search/item/count?keyword=${keyword}`)
  },
  getProductSubCategories(categoryId) {
    return axios.get(`${host}/api/public/product/category?categoryId=${categoryId}`)
  },
  getProductsByCategory(categoryId) {
    return axios.get(`${host}/api/public/product/list/category?categoryId=${categoryId}`)
  },
  getServiceSubCategories(categoryId) {
    return axios.get(`${host}/api/public/service/category?categoryId=${categoryId}`)
  },
  getServicesByCategory(categoryId) {
    return axios.get(`${host}/api/public/service/list/category?categoryId=${categoryId}`)
  },
  getProductDetails(productId) {
    return axios.get(`${host}/api/public/product/detail?productId=${productId}`)
  },
  getServiceDetails(serviceId) {
    return axios.get(`${host}/api/public/service/detail?serviceId=${serviceId}`)
  },
  getCompany(companyId) {
    return axios.get(`${host}/api/public/tenant/website?tenantId=${companyId}`)
  },
  getHostDashboardUrl() {
    return (`${hostDashboard}`)
  },
  getCompanyProductList(tenantId,searchKey,RowsPerPage,PageNumber) {
    return axios.get(`${host}/api/public/tenant/website/product/list?tenantId=${tenantId}&searchKey=${searchKey}&RowsPerPage=${RowsPerPage}&PageNumber=${PageNumber}`)
  },
  getCompanyServiceList(tenantId,searchKey,RowsPerPage,PageNumber) {
    return axios.get(`${host}/api/public/tenant/website/service/list?tenantId=${tenantId}&searchKey=${searchKey}&RowsPerPage=${RowsPerPage}&PageNumber=${PageNumber}`)
  },
  login(username, password) {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    params.append('grant_type', 'password');

   // return 
    return axios.post(`${host}/api/tenant/auth`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });

  
    
  },
  register(email, password, name, mobile, category) {
    return axios.post(`${host}/api/login/tenant/register`, {
      Email: email,
      Password: password,
      Name : name,
      MobileNo: mobile,
      Category: category
    })
  }, 
  passwordRecovery(email) {
    return axios.put(`${host}/api/Admin/password/recovery`, {
      emailTo: email
    })
  }, 
  contactUs(name,email,message) {

    console.log('name :::::::::: ', name);
    console.log('email :::::::::: ', email);
    console.log('message :::::::::: ', message);

    return axios.put(`${host}/api/Admin/contact/us`, {
      email: email,
      name: name,
      message: message
    })
  }, 
  addEmailNewsletter(email) {
    return axios.post(`${host}/api/public/newsletter/add`, {
      email: email
    })
  },

  addRfq(categoryTypeId, title, quantity, toTenantId, rfqBody, fromUserId, productName, productServiceId, productUomId, attachmentUrl, fileName) {

    /*
    console.log("addRfq categoryTypeId ::::::::::: ", categoryTypeId);
    console.log("addRfq title ::::::::::: ", title);
    console.log("addRfq quantity ::::::::::: ", quantity);
    console.log("addRfq toTenantId ::::::::::: ", toTenantId);
    console.log("addRfq rfqBody ::::::::::: ", rfqBody);
    console.log("addRfq fromUserId ::::::::::: ", fromUserId);
    console.log("addRfq productName ::::::::::: ", productName);
    console.log("addRfq productServiceId ::::::::::: ", productServiceId);
    console.log("addRfq productUomId ::::::::::: ", productUomId);
    */   
    
    return axios.post(`${host}/api/public/rfq/new2?attachmentUrl=${attachmentUrl}&fileName=${fileName}`, {
      categoryTypeId: categoryTypeId,
      title: title,
      quantity : quantity,
      toTenantId: toTenantId,
      rfqBody: rfqBody,
      fromUserId: fromUserId,
      productName: productName,
      productServiceId: productServiceId,
      productUomId: productUomId,
    })
    
    
  },

  addChat(selectedUser, messag, fromUserId) {
    
    return axios.post(`${host}/api/public/chat`, {
      selectedUser: selectedUser,
      messag: messag,
      fromUserId : fromUserId
    })
    
    
  },


  addInquiry(title, toTenantId, rfqBody, fromUserId, attachmentUrl, fileName) {
    return axios.post(`${host}/api/public/inquiry/new2`, {
      title: title,
      toTenantId: toTenantId,
      inquiryBody: rfqBody,
      fromUserId: fromUserId,
      attachmentUrl: attachmentUrl,
      fileName: fileName
    })
      .then(resp => {
        // console.log('result :::: ', resp.data.Item1.Id);
        // console.log('result :::: ', resp.data.Item2);
        return resp;
      })
      .catch (error => {
        console.error('Error uploading file', error);
      })
    
  },

  userDetails() {
    return axios.get(`${host}/api/login/userdetail`)
  },

  // Chat Function
  ChatMenu(FromUserId) {
    return axios.get(`${host}/api/public/user/chatMenu?fromUserId=${FromUserId}`)
  },
  MessageList(ChatId,StaffStatus) {
    return axios.get(`${host}/api/public/user/getchathistory?ChatId=${ChatId}&StaffStatus=${StaffStatus}`)
  },

  addNewChat(Title, ToTenantId, MessageBody, FromUserId) {

    return axios.post(`${host}/api/public/user/addNewChat`, {
      Title: Title,
      ToTenantId: ToTenantId,
      MessageBody: MessageBody,
      FromUserId: FromUserId,
    })
  },
  updateChat(ChatId, MessageBody, FromUserId, StaffStatus ) {

    return axios.post(`${host}/api/public/user/updateChatHistory`, {
      ChatId: ChatId, 
      MessageBody: MessageBody,
      FromUserId: FromUserId,
      StaffStatus: StaffStatus
    })
    
  },

  uploadFileInquiryDoc(file) {
    const formData = new FormData();
    formData.append('file', file);

    // console.log('masuk api.js');
    return axios.post(`${host}/api/upload/Public/Inquiry/Doc`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }) 
      .then(resp => {
        // console.log('RESULT :::: ',resp.data.Result[0].DocFileName);
        return resp.data.Result[0].DocFileName;
      })
      .catch (error => {
        console.error('Error uploading file', error);

      });
  },

  uploadFileServiceRfqDoc(file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${host}/api/upload/Public/Services/Rfq/Doc`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(resp => {
        return resp.data.Result[0].DocFileName;
      })
      .catch (error => {
        console.error('Error uploading file', error);
      });
  },

  uploadFileProductRfqDoc(file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${host}/api/upload/Public/Products/Rfq/Doc`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(resp => {
        return resp.data.Result[0].DocFileName;
      })
      .catch (error => {
        console.error('Error uploading file', error);
      });
  },

  pushEmailInquiry(tenantInquiryId, tenantInquiryHistoryId) {
    return axios.post(`${host}/api/public/Inquiry/Email?tenantInquiryId=${tenantInquiryId}&inquiryHistoryId=${tenantInquiryHistoryId}`);
  }

}
